import { render, staticRenderFns } from "./PropertyEdit.vue?vue&type=template&id=9c3893ac&scoped=true"
import script from "./PropertyEdit.vue?vue&type=script&lang=js"
export * from "./PropertyEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3893ac",
  null
  
)

export default component.exports